import React, { useState, useEffect } from 'react';

const EditEducationModal = ({ isOpen, onClose, onEducationUpdated, educationToEdit, editingIndex }) => {
  const [formData, setFormData] = useState({
    institution: '',
    degree: '',
    fieldOfStudy: '',
    startDate: '',
    endDate: '',
    grade: '',
    location: '',
    description: ''
  });
  const [error, setError] = useState('');

  // Update form data when educationToEdit changes
  useEffect(() => {
    if (educationToEdit) {
      setFormData({
        institution: educationToEdit.institution || '',
        degree: educationToEdit.degree || '',
        fieldOfStudy: educationToEdit.fieldOfStudy || '',
        startDate: educationToEdit.startDate || '',
        endDate: educationToEdit.endDate || '',
        grade: educationToEdit.grade || '',
        location: educationToEdit.location || '',
        description: educationToEdit.description || ''
      });
    }
  }, [educationToEdit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.institution.trim() || !formData.degree.trim()) {
      setError('Institution and degree are required');
      return;
    }

    try {
      setError('');
      
      // Notify parent component
      onEducationUpdated(editingIndex, formData);
      
      // Close modal
      onClose();
    } catch (error) {
      console.error('Error updating education:', error);
      setError('Error updating education. Please try again.');
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  if (!isOpen || !educationToEdit) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Education</h2>
          <button 
            onClick={handleClose} 
            className="modal-close"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Institution *</label>
              <input
                type="text"
                value={formData.institution}
                onChange={(e) => setFormData({...formData, institution: e.target.value})}
                className="input-field"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Degree *</label>
              <input
                type="text"
                value={formData.degree}
                onChange={(e) => setFormData({...formData, degree: e.target.value})}
                className="input-field"
                placeholder="e.g., Bachelor of Science"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Field of Study</label>
            <input
              type="text"
              value={formData.fieldOfStudy}
              onChange={(e) => setFormData({...formData, fieldOfStudy: e.target.value})}
              className="input-field"
              placeholder="e.g., Computer Science"
            />
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                value={formData.startDate}
                onChange={(e) => setFormData({...formData, startDate: e.target.value})}
                className="input-field"
              />
            </div>
            <div className="form-group">
              <label className="form-label">End Date</label>
              <input
                type="date"
                value={formData.endDate}
                onChange={(e) => setFormData({...formData, endDate: e.target.value})}
                className="input-field"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Grade/GPA</label>
              <input
                type="text"
                value={formData.grade}
                onChange={(e) => setFormData({...formData, grade: e.target.value})}
                className="input-field"
                placeholder="e.g., 3.8/4.0 or First Class"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Location</label>
              <input
                type="text"
                value={formData.location}
                onChange={(e) => setFormData({...formData, location: e.target.value})}
                className="input-field"
                placeholder="City, State/Country"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              rows={3}
              className="input-field textarea-field"
              placeholder="Describe your academic achievements, relevant coursework, or research projects..."
            />
          </div>
          
          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              Update Education
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEducationModal; 